import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import Footer from '../../bundles/comments/components/Footer/ror_components/Footer.jsx';

ReactOnRails.register({Footer});